enum PlanTypes {
  TRAINING = "TRAINING",
}

export default PlanTypes;
